import axios from 'axios';
import buildPaginationQueryOpts from '@/shared/sort/sorts';
import {ITaskGroupSave} from '@/shared/model/resolution/taskGroup.model';
import {IMyBadgeCard} from '@/shared/model/dashboard/my-badge-card.model';

const baseApiUrl = 'api/task-groups';

export default class TaskGroupService {
  public getCurrentUserTaskGroups(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public getTaskGroupMembers(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public getTaskListGroupMembers(ids: any): Promise<any> {

    return new Promise<any>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/multiple_select`, ids)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public save(entity: ITaskGroupSave): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
